import { render, staticRenderFns } from "./lineBox.vue?vue&type=template&id=168bd766&scoped=true&"
import script from "./lineBox.vue?vue&type=script&lang=js&"
export * from "./lineBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168bd766",
  null
  
)

export default component.exports